module.exports = __webpack_public_path__ + "img/1.250bfe4e.png";